import { create } from "zustand";

const useAthleteprofileStore = create((set) => ({
  currentContentTab: {
    id: 1,
    name: "Highlights",
  },
  setCurrentContentTab: (value) => set({ currentContentTab: value }),

  currentTournamentsTab: null,
  setCurrentTournamentsTab: (value) => set({ currentTournamentsTab: value }),

  currentStatsData: {},
  setCurrentStatsData: (value) => set({ currentStatsData: value }),
}));

export default useAthleteprofileStore;
